// src/components/ProtectedRoute.js
import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { YearContext } from "../contexts/YearContext";

const ProtectedRoute = () => {
  const { submitDate, loading } = useContext(YearContext);
  const currentDate = new Date();

  console.log('ProtectedRoute check:');
  console.log('Current date:', currentDate);
  console.log('Submit date:', submitDate);
  console.log('Current > Submit:', currentDate > submitDate);
  console.log('YearContext loading:', loading);

  // Don't redirect while loading
  if (loading || !submitDate) {
    console.log('YearContext still loading, waiting...');
    return <div>Loading...</div>;
  }

  // Redirect if the current date is after the submit date
  if (currentDate > submitDate) {
    console.log('Redirecting to /compare because current date is after submit date');
    return <Navigate to="/compare" />;
  }

  console.log('Allowing access to predictions page');
  // Render the component if within the allowed time
  return <Outlet />;
};

export default ProtectedRoute;
